RadioInput = React.createClass
  displayName: 'RadioInput'

  render: ->
    <input {...@props} type="radio" />

module.exports = RadioInput
